import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ANIMATIONS_NAME_MAP;
export var DEFAULT_CONTAINER_CLASS_NAME = 'continuous-scroll-container';
export var HORIZONTAL_DIRECTION = 'horizontal';
export var VERTICAL_DIRECTION = 'vertical';
export var ANIMATIONS_NAME_MAP = (_ANIMATIONS_NAME_MAP = {}, _defineProperty(_ANIMATIONS_NAME_MAP, HORIZONTAL_DIRECTION, 'horizontalScroll'), _defineProperty(_ANIMATIONS_NAME_MAP, VERTICAL_DIRECTION, 'verticalScroll'), _ANIMATIONS_NAME_MAP);
export var DEFAULT_INTERSECTION_OBSERVER_THRESHOLD = 0.2;
export var DEFAULT_INTERSECTION_OBSERVER_ROOT_MARGIN = '0px';
export var POST_LOAD_RE_RENDER_DELAY_MS = 500;
export var DEFAULT_ANIMATION_DURATION_SECONDS = 26;
export var EAGER_LOAD_STRATEGY = 'eager';
export var IN_VIEWPORT_LOAD_STRATEGY = 'inViewport';
export var CONTINUOUS_SCROLL_LOAD_STRATEGIES = [EAGER_LOAD_STRATEGY, IN_VIEWPORT_LOAD_STRATEGY];